import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { createLoadingSelector } from "../redux/selectors";

class Sticky extends Component {
  static baseClass = "sticky-wrapper";

  state = {
    height: 0,
    width: 0,
    stuck: false,
    atTop: true,
  };

  componentDidMount() {
    this.addEvents();
    this.handleScroll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.scrollTarget !== this.props.scrollTarget) {
      this.removeEvents();
      this.addEvents();
    }
  }

  componentWillUnmount() {
    this.removeEvents();
  }

  frameId = 0;

  stickyDiv = React.createRef();

  handleScroll = () => {
    const stickyDiv = this.stickyDiv.current || null;
    const scrollTarget = this.props.scrollTarget || window;

    this.frameId = 0;

    if (!stickyDiv) {
      return;
    }

    let scrollRect = {
      // scrollTarget is the window
      height: scrollTarget.innerHeight,
      top: 0,
      y: scrollTarget.scrollY,
    };

    if (scrollTarget.getBoundingClientRect) {
      // scrollTarget is not the window
      scrollRect = scrollTarget.getBoundingClientRect();
    }

    let stickyRect = stickyDiv.getBoundingClientRect();

    if (!this.state.height) {
      this.setState({
        height: stickyRect.height,
      });
    }

    stickyRect = {
      // Apparently you can't spread the results of a bounding client rectangle
      height: this.state.height || stickyRect.height,
      y: stickyRect.y,
    };

    if (stickyRect.y < scrollRect.top) {
      this.setState({ stuck: true, atTop: false });
    } else {
      this.setState({ stuck: false, atTop: true });
    }
  };

  setSticky = (flag) => {
    if (this.state.atTop) {
      this.setState({ stuck: flag });
    }
  };

  debouncedScroll = () => {
    if (!this.frameId) {
      const frameId = requestAnimationFrame(this.handleScroll);
      this.frameId = frameId;
    }
  };

  addEvents() {
    const scrollTarget = this.props.scrollTarget || window;

    if (scrollTarget && this.stickyDiv.current) {
      scrollTarget.addEventListener("scroll", this.debouncedScroll);
    }
  }

  removeEvents() {
    const scrollTarget = this.props.scrollTarget || window;

    if (scrollTarget) {
      scrollTarget.removeEventListener("scroll", this.debouncedScroll);
    }

    if (this.frameId) {
      cancelAnimationFrame(this.frameId);
    }
  }

  render() {
    const { children, isLoading } = this.props;
    let { stuck } = this.state;
    const stickyModifiers = [];

    stuck = stuck | isLoading;
    if (stuck) {
      stickyModifiers.push("navbar-light");
      stickyModifiers.push("shrink");
      stickyModifiers.push("stick-top");
    }

    const childrenWithStuckProps = React.Children.map(children, (child) => {
      const childModifiers = (child.props && child.props.modifiers) || [];
      return React.cloneElement(child, {
        modifiers: [...childModifiers, ...stickyModifiers],
        setSticky: this.setSticky,
      });
    });

    return stuck ? (
      <div className={`${Sticky.baseClass} is-sticky`} ref={this.stickyDiv}>
        {childrenWithStuckProps}
      </div>
    ) : (
      <div className={Sticky.baseClass} ref={this.stickyDiv}>
        {childrenWithStuckProps}
      </div>
    );
  }
}

Sticky.propTypes = {
  children: PropTypes.node.isRequired,
  scrollTarget: PropTypes.object,
};

Sticky.defaultProps = {
  scrollTarget: null,
};

// export default Sticky;

const loadingSelector = createLoadingSelector(["FETCH_SUBJECTS"]);

const mapStateToProps = (state) => ({
  isLoading: loadingSelector(state),
});

export default connect(mapStateToProps, null)(Sticky);
